import './CustomLoading.scss';
import React, { memo } from 'react';
import { LoadingSpinner } from 'src/modules/common/icons/LoadingSpinner';

export const CustomLoading = memo(() => (
  <div className="bp-custom-loading">
    <LoadingSpinner/>
  </div>
));
